import { DpContainer, DpContainerProps } from '@/components/blocks/DpContainer';
import { BreadcrumbTrail } from '@/components/content/BreadcrumbTrail';

interface DpBreadcrumbTrailProps extends DpContainerProps {
	withoutmargin?: boolean;
	isPLP?: boolean;
}

export const DpBreadcrumbTrail = (props: DpBreadcrumbTrailProps) => (
	<DpContainer withoutmargin isPLP {...props}>
		<BreadcrumbTrail id="breadcrumb-trail" />
	</DpContainer>
);
